import { Trans, useTranslation } from "react-i18next";
import { useAuth } from "../../hooks";
import { useForm } from "react-hook-form";
import React, { useCallback } from "react";
import {
  ModalHeader,
  Modal,
  ModalContent,
  ModalOverlay,
  Heading,
  FormLabel,
  useToast,
  FormControl,
  FormErrorMessage,
  Input,
  Button,
  ModalFooter,
} from "@chakra-ui/react";
import { ModalBody } from "amazon-chime-sdk-component-library-react";

const ConfirmSignInModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { confirmSignIn } = useAuth();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = useCallback(
    (values) => {
      return new Promise((resolve) => {
        confirmSignIn(values)
          .then(() => {
            onClose();
          })
          .catch((error) => {
            if (!toast.isActive(error.message)) {
              toast({
                id: error.message,
                title: error.message,
                status: "error",
                position: "top",
                duration: 5000,
              });
            }
          })
          .finally(() => {
            resolve();
          });
      });
    },
    [confirmSignIn, onClose, toast],
  );
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent padding={4}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            <Heading>
              <Trans>login.confirm.title</Trans>
            </Heading>
          </ModalHeader>
          <ModalBody>
            <FormControl isInvalid={errors.newPassword}>
              <FormLabel htmlFor={"newPassword"}>
                <Trans>login.newPassword.title</Trans>
              </FormLabel>
              <Input
                backgroundColor={"white"}
                id={"newPassword"}
                placeholder={t("login.newPassword.placeholder")}
                size={"sm"}
                type={"password"}
                {...register("newPassword", {
                  required: t("login.newPassword.required"),
                })}
              />
              <FormErrorMessage>
                {errors.newPassword && errors.newPassword.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.newPasswordConfirm}>
              <FormLabel htmlFor={"newPasswordConfirm"}>
                <Trans>login.newPasswordConfirm.title</Trans>
              </FormLabel>
              <Input
                backgroundColor={"white"}
                id={"newPasswordConfirm"}
                placeholder={t("login.newPasswordConfirm.placeholder")}
                size={"sm"}
                type={"password"}
                {...register("newPasswordConfirm", {
                  required: t("login.pasnewPasswordConfirmsword.required"),
                  validate: (value, formValues) =>
                    value === formValues.newPassword ||
                    t("login.newPasswordConfirm.doesNotMatch"),
                })}
              />
              <FormErrorMessage>
                {errors.newPasswordConfirm && errors.newPasswordConfirm.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              isLoading={isSubmitting}
              size={"md"}
              type={"submit"}
              variant="secondary"
            >
              Confirm
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default React.memo(ConfirmSignInModal);
